//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import { refundStatusNumApi, refundListApi, refundMarkApi, orderPrint, orderAuditApi, refundOrderReceivingRejectApi } from '@/api/order';
import { isWriteOff } from '@/utils';
import { orderExcelApi } from '@/api/product';
import { checkPermi } from '@/utils/permission';
import RefundOrderDetail from '../components/refundOrderDetail.vue';
import { refundStatusFilter } from '@/filters';
import useRefundOrder from '@/libs/useRefundOrder';
import AgreeToReturn from '@/views/order/components/agreeToReturn.vue';
import RefundOrderRebates from '@/views/order/components/refundOrderRebates.vue';
import * as $constants from '@/utils/constants';
var _useRefundOrder = useRefundOrder(),
  onConfirmReceipt = _useRefundOrder.onConfirmReceipt,
  onApprovedReview = _useRefundOrder.onApprovedReview;
var tableFroms = {
  refundStatus: '9',
  dateLimit: '',
  orderNo: '',
  refundOrderNo: '',
  page: 1,
  limit: $constants.page.limit[0],
  searchType: 'all',
  content: '',
  trackingNumber: ''
};
// 权限判断函数
export default {
  name: 'orderRefund',
  components: {
    AgreeToReturn: AgreeToReturn,
    RefundOrderDetail: RefundOrderDetail,
    RefundOrderRebates: RefundOrderRebates
  },
  data: function data() {
    return {
      datekey: Date.now(),
      RefuseData: {},
      refundOrderNo: '',
      //退款单号
      refundData: {},
      tableDataLog: {
        data: [],
        total: 0
      },
      LogLoading: false,
      isCreate: 1,
      editData: null,
      dialogVisible: false,
      tableData: {
        data: [],
        total: 0
      },
      listLoading: true,
      tableFrom: Object.assign({}, tableFroms),
      orderChartType: {},
      timeVal: [],
      fromList: this.$constants.fromList,
      selectionList: [],
      ids: '',
      orderids: '',
      cardLists: [],
      isWriteOff: isWriteOff(),
      proType: 0,
      active: false,
      card_select_show: false,
      checkAll: false,
      checkedCities: ['退款单号', '订单号', '用户昵称', '退款金额', '退款状态', '售后类型', '退货类型', '强制退款', '创建时间'],
      columnData: ['退款单号', '订单号', '用户昵称', '退款金额', '退款状态', '售后类型', '退货类型', '强制退款', '创建时间'],
      isIndeterminate: true,
      dialogVisibleAgreeToReturn: false,
      refundInfo: null,
      drawerVisible: false,
      tagClass: ['doingTag', 'notStartTag', 'doingTag', 'endTag', 'notStartTag', 'doingTag', 'endTag'],
      // 指定退款
      dialogVisibleOrderRebates: false,
      refundOrderNoForRebates: '',
      // 用于指定退款的退款单号
      type: 0
    };
  },
  mounted: function mounted() {
    if (checkPermi(['merchant:refund:order:page:list'])) this.getList();
    if (checkPermi(['merchant:refund:order:status:num'])) this.getOrderStatusNum();
  },
  methods: {
    checkPermi: checkPermi,
    needsReturnAddress: function needsReturnAddress(row) {
      return row.afterSalesType === 2 && row.returnGoodsType === 1;
    },
    //商家确认收货
    handleConfirmReceipt: function handleConfirmReceipt(refundOrderNo) {
      var _this = this;
      onConfirmReceipt(refundOrderNo).then(function () {
        _this.handleSearchList();
      });
    },
    //审核同意
    handleApprovedReview: function handleApprovedReview(row) {
      // 退货退款(快递退回)必须先选择商家退货地址，再进入用户寄回流程
      if (this.needsReturnAddress(row)) {
        this.refundInfo = row;
        this.dialogVisibleAgreeToReturn = true;
        return;
      }
      // 仅退款或非快递退回场景，走指定退款弹窗
      this.refundOrderNoForRebates = row.refundOrderNo;
      this.type = row.type;
      this.dialogVisibleOrderRebates = true;
    },
    //审核成功回调
    handleSuccess: function handleSuccess() {
      this.dialogVisibleAgreeToReturn = false;
      this.handleSearchList();
    },
    //同意弹窗
    handleCloseAgreeToReturn: function handleCloseAgreeToReturn() {
      this.dialogVisibleAgreeToReturn = false;
    },
    //审核拒绝
    handleOrderRefuse: function handleOrderRefuse(row) {
      var _this2 = this;
      this.$modalPrompt('textarea', '拒绝退款原因', null).then(function (V) {
        orderAuditApi({
          auditType: 'refuse',
          reason: V,
          refundOrderNo: row.refundOrderNo
        }).then(function () {
          _this2.$message.success('审核成功');
          _this2.handleSearchList();
        });
      });
    },
    //拒绝收货
    handleRefuseReceipt: function handleRefuseReceipt(row) {
      var _this3 = this;
      this.$modalPrompt('textarea', '拒绝收货原因', null).then(function (V) {
        refundOrderReceivingRejectApi({
          reason: V,
          refundOrderNo: row.refundOrderNo
        }).then(function () {
          _this3.$message.success('拒绝收货成功');
          _this3.handleSearchList();
        });
      });
    },
    // 指定退款
    onRebates: function onRebates(row) {
      if (this.needsReturnAddress(row)) {
        this.refundInfo = row;
        this.dialogVisibleAgreeToReturn = true;
        return;
      }
      this.refundOrderNoForRebates = row.refundOrderNo;
      this.type = row.type;
      this.dialogVisibleOrderRebates = true;
    },
    // 指定退款关闭
    handlerSuccessRebatesClose: function handlerSuccessRebatesClose() {
      this.dialogVisibleOrderRebates = false;
    },
    // 指定退款成功回调
    handlerSuccessRebatesSubmit: function handlerSuccessRebatesSubmit() {
      this.dialogVisibleOrderRebates = false;
      this.handleSearchList();
    },
    //重置
    handleReset: function handleReset() {
      this.tableFrom.dateLimit = '';
      this.tableFrom.orderNo = '';
      this.tableFrom.refundOrderNo = '';
      this.tableFrom.content = '';
      this.tableFrom.searchType = 'all';
      this.tableFrom.trackingNumber = '';
      this.selectChange();
    },
    //搜索
    handleSearchList: function handleSearchList() {
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    onClosedrawerVisible: function onClosedrawerVisible() {
      this.drawerVisible = false;
    },
    //详情中审核成功回调
    getReviewSuccessful: function getReviewSuccessful() {
      this.handleSearchList();
    },
    // 详情
    onOrderDetails: function onOrderDetails(row) {
      this.refundOrderNo = row.refundOrderNo;
      this.drawerVisible = true;
    },
    // 备注
    onOrderMark: function onOrderMark(row) {
      var _this4 = this;
      this.$modalPrompt('textarea', '备注', row.merRemark, '退款单备注').then(function (V) {
        refundMarkApi({
          remark: V,
          refundOrderNo: row.refundOrderNo
        }).then(function () {
          _this4.$message.success('操作成功');
          _this4.getList();
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectionList = val;
      var data = [];
      this.selectionList.map(function (item) {
        data.push(item.orderNo);
      });
      this.ids = data.join(',');
    },
    // 选择时间
    selectChange: function selectChange(tab) {
      this.timeVal = [];
      this.tableFrom.page = 1;
      this.handleSearchList();
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.handleSearchList();
    },
    // 列表
    getList: function getList() {
      var _this5 = this;
      this.listLoading = true;
      refundListApi(this.tableFrom).then(function (res) {
        _this5.tableData.data = res.list || [];
        _this5.tableData.total = res.total;
        _this5.listLoading = false;
        _this5.checkedCities = _this5.$cache.local.has('order_refund_stroge') ? _this5.$cache.local.getJSON('order_refund_stroge') : _this5.checkedCities;
      }).catch(function () {
        _this5.listLoading = false;
      });
    },
    // 获取各状态数量
    getOrderStatusNum: function getOrderStatusNum() {
      var _this6 = this;
      var data = Object.assign({}, this.tableFrom);
      delete data.page;
      delete data.limit;
      delete data.refundStatus;
      refundStatusNumApi(data).then(function (res) {
        _this6.orderChartType = res;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    exports: function exports() {
      var data = {
        dateLimit: this.tableFrom.dateLimit,
        orderNo: this.tableFrom.orderNo,
        refundStatus: this.tableFrom.status,
        type: this.tableFrom.type
      };
      orderExcelApi(data).then(function (res) {
        // 使用域名，不带/api
        var baseUrl = process.env.VUE_APP_BASE_API.replace(/\/api$/, '');
        var fileName = res.fileName.startsWith('/') ? res.fileName : '/' + res.fileName;
        window.open(baseUrl + fileName);
      });
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.$set(this, 'card_select_show', false);
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('order_refund_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    },
    //打印小票
    onOrderPrint: function onOrderPrint(data) {
      var _this7 = this;
      orderPrint(data.orderNo).then(function (res) {
        _this7.$modal.msgSuccess('打印成功');
      }).catch(function (error) {
        _this7.$modal.msgError(error.message);
      });
    }
  }
};